<ng-lottie [options]="options" (animationCreated)="onAnimationCreated($event)"></ng-lottie>
